export const PEDIATRIC_SELF_REPORT_JWT_TYP = 'pediatricSelfReport';
export const SELF_REPORT_LINK_HEADER = 'X-Self-Report-Link';
export const SELF_REPORT_METADATA_PATH = 'self-reports/current';
export const SELF_REPORT_SESSION_PATH = 'self-reports/sessions';
export const SELF_REPORT_PIN_RESET_PATH = 'self-reports/sessions/pin-reset';
export const SELF_REPORT_VERIFY_PATH = 'self-reports/sessions/verify';
export const SELF_REPORT_FORM_PATH = 'self-reports/sessions/current/form';
export const SELF_REPORT_STUDY_TEMPLATE_PATH =
  'self-reports/sessions/current/study-template';
export const SELF_REPORT_TODAY_PATH = 'self-reports/sessions/current/today';
export const SELF_REPORT_ENCOURAGEMENT_PATH =
  'self-reports/sessions/current/encouragement';

export interface SelfReportSession {
  accessToken: string;
  tokenId: number;
  studyParticipantId: number;
  pediatricUserId: number;
}

export function parseSelfReportSessionToken(
  accessToken?: string
): SelfReportSession | undefined {
  if (!accessToken) {
    return undefined;
  }
  const payloadPart = accessToken.split('.')[1];
  if (!payloadPart) {
    return undefined;
  }
  try {
    const normalized = payloadPart.replace(/-/g, '+').replace(/_/g, '/');
    const padded = normalized.padEnd(Math.ceil(normalized.length / 4) * 4, '=');
    const payload = JSON.parse(globalThis.atob(padded));
    if (
      payload?.typ !== PEDIATRIC_SELF_REPORT_JWT_TYP ||
      !Number.isInteger(payload.tokenId) ||
      !Number.isInteger(payload.studyParticipantId) ||
      !Number.isInteger(payload.pediatricUserId)
    ) {
      return undefined;
    }
    return {
      accessToken,
      tokenId: payload.tokenId,
      studyParticipantId: payload.studyParticipantId,
      pediatricUserId: payload.pediatricUserId
    };
  } catch {
    return undefined;
  }
}

export function getSelfReportTokenFromLocation(
  pathToken?: string,
  search?: string
) {
  if (pathToken) {
    return pathToken;
  }
  if (!search) {
    return undefined;
  }
  try {
    return (
      new URLSearchParams(search.replace(/^\?/, '')).get('token') || undefined
    );
  } catch {
    return undefined;
  }
}

export function selfReportWebUrl(url: string, webBaseUrl: string) {
  const base = webBaseUrl.replace(/\/+$/, '');
  const isSelfReportUrl = (value: string) => /self-report/i.test(value);
  const tokenFromSelfReportText = () => {
    if (!isSelfReportUrl(url)) {
      return undefined;
    }
    const pathMatch = url.match(/self-report\/([^/?#]+)/i);
    const queryMatch = url.match(/[?&]token=([^&]+)/i);
    return pathMatch?.[1] || queryMatch?.[1] || undefined;
  };
  try {
    const parsed = new URL(url);
    const path = `${parsed.hostname || ''}${parsed.pathname}`.replace(
      /\/+$/,
      ''
    );
    const match = path.match(/self-report(?:\/([^/?#]+))?$/i);
    if (!match) {
      return undefined;
    }
    const token = match[1] || parsed.searchParams.get('token') || undefined;
    return token ? `${base}/self-report/${token}` : `${base}/self-report`;
  } catch {
    if (!isSelfReportUrl(url)) {
      return undefined;
    }
    const token = tokenFromSelfReportText();
    return token ? `${base}/self-report/${token}` : `${base}/self-report`;
  }
}
